import { render, staticRenderFns } from "./CenterStar.vue?vue&type=template&id=5a9eece8&scoped=true"
import script from "./CenterStar.vue?vue&type=script&lang=js"
export * from "./CenterStar.vue?vue&type=script&lang=js"
import style0 from "./CenterStar.vue?vue&type=style&index=0&id=5a9eece8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9eece8",
  null
  
)

export default component.exports